<template>
<div class="app has-header">
    <div class="header">
        <div class="icons-submenu">
            
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 1}" @click="viewMode = 1">
                <div class="label">Ansicht</div>
            </div>
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 2}" @click="viewMode = 2">
                <div class="label">Übersicht</div>
            </div>
        </div>

        
        
    </div>
   
    <preferenceview v-if="viewMode == 1" :currentDay="currentDay"></preferenceview>
    <employeepreferenceoverview v-if="viewMode == 2"></employeepreferenceoverview>

</div>
</template>

<script>

import employeepreferenceoverview from '../preferencecontext/EmployeePreferenceOverview.vue'
import preferenceview from '../preferencecontext/PreferenceView.vue'


export default {
    components: {
        employeepreferenceoverview,
        preferenceview
    },
    name: 'PreferenceMain',
    data() {
        return {
            viewMode: this.mode == null ? 1 : this.mode,
            loading: true,
        }
    },
    watch: {},
    props: ['mode', 'currentDay'],
    created() {

    },
    mounted(){
        
    },
    updated() {},
    destroyed() {},
    methods: {
        
    }
}
</script>